export const firstWord = (text: string) => text.split(" ")[0]
